import { gql } from '@apollo/client';

export const SEARCH_QUESTIONS_PAGINATED = gql`
  query SearchQuestionsPaginated($query: String!, $tag: String, $limit: Int!, $offset: Int!) {
    searchQuestionsPaginated(query: $query, tag: $tag, limit: $limit, offset: $offset) {
      questions {
        id
        prompt
        options {
          desc
          isAnswer
        }
        explanation
        tag
        label
      }
      totalCount
      hasMore
    }
  }
`;
